import { Component, ViewEncapsulation } from '@angular/core';

import { BaseSummaryControlDirective } from '../base/base-summary-control';
import { VraagboomTimeResultaat } from '@models/vragenboom';
import { FormatHelper } from '@services/public_api';

@Component({
  selector: 'app-time-picker-summary',
  templateUrl: './time-picker-summary.component.html',
  styleUrls: ['./time-picker-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TimePickerSummaryComponent extends BaseSummaryControlDirective<VraagboomTimeResultaat> {

  constructor() {
    super();
  }

  geefAntwoord(): string {
    if (this.antwoordResultaat?.resultaat) {
      return FormatHelper.formatTime(this.antwoordResultaat.resultaat.uren, this.antwoordResultaat.resultaat.minuten);
    }
    return '';
  }
}
